import FindAddressesForPostcode from '@/services/logistics/postcodeLookupService/FindAddressesForPostcode';
import LegacyFetchAddressesForPostcode from '@/services/logistics/postcodeLookupService/LegacyFetchAddressesForPostcode';

export default class PostcodeLookupService {
    async fetchAddressesForPostcode(postcode) {
        return (new LegacyFetchAddressesForPostcode()).handle(postcode);
    }

    static findAddressesForPostcode(postcode, countryIso = 'de') {
        return (new FindAddressesForPostcode()).handle(postcode, countryIso);
    }
}
